import React from "react";
import {observer} from "mobx-react";

import "./legend.scss";

import {LegendConfiguration, LegendStyleType} from "../../../../config/legend-configuration";
import {LegendItemList} from "./legend-item-list/legend-item-list";
import {TopicConfiguration} from "../../../../config/topic-configuration";
import {IAppStore, withStore} from "../../../../core/stores/abstract-app-store";


interface LegendProps {
    config: LegendConfiguration;
    store?: IAppStore; // this is injected by withStore
}

@observer
class LegendBase extends React.Component<LegendProps, any> {
    widgetKey = "legend";
    constructor(props: LegendProps) {
        super(props);
        this.state = {
            visible: true
        };
    }

    render(): JSX.Element | null {
        if (!this.state.visible) {
            return null;
        }

        const {store} = this.props;
        if (!store) {
            return null;
        }

        const topic = store.appStore.subtopic as TopicConfiguration;
        let content;
        if (!topic) {
            content = <span className={"info"}>Fachbereich auswählen...</span>;
        }

        if (!this.props.config.style || this.props.config.style.type === LegendStyleType.List) {
            content = (
                <LegendItemList
                    topic={topic}
                    layerInfos={this.props.config.layerInfos} />);
        }
        // TODO: Implement legend in card layout

        return (
            <div>
                <div className="geo-legend">
                    <div className="geo-legend-body">
                        {content}
                    </div>
                </div>
                <div className="geo-legend-footer"/>
            </div>
        );

    }
    componentDidMount(): void {
        const {store} = this.props;
        if (!store?.uiStore.widgets.has(this.widgetKey)) {
            store?.uiStore.addWidget(this.widgetKey, this);
        }
    }
    componentWillUnmount(): void {
        const {store} = this.props;
        store?.uiStore.removeWidget(this.widgetKey);
    }
}

export const Legend = withStore(LegendBase);
